module.exports = __webpack_public_path__ + "img/adaptations6.5a9cf80d.png";